import { useState, useEffect, useRef } from "react";
import MultiRangeSlider from "multi-range-slider-react";
import { useTranslation } from "react-i18next";
import "themes/multi-range.css";
import { SwalAlertClass } from "core/swalClass";
import axiApi from "ApiCaller";
import { ContainerProgressCircle } from "components/waste-icons/svgs/ContainerProgressCircle";

const ContainersRange = ({ range, updateRange }) => {
    const Alert = new SwalAlertClass({ confirmButtonText: "Aceptar" });
    const { t: _Tt } = useTranslation("tables");
    const { t: _Tf } = useTranslation("forms");
    const [minValue, setMinValue] = useState(60);
    const [maxValue, setMaxValue] = useState(100);
    const [wastes, setWastes] = useState([]);
    const [totals, setTotals] = useState({ total: 0, count: 0 });
    const styleText = {
        backgroundColor: "#676767",
        color: "white",
        padding: "2px",
        fontWeight: 800,
    };
    const apiDuplicated = useRef(false);
    const getContainers = (min, max) => {
        updateRange({ min: min, max: max });
        /*if (apiDuplicated.current) {

            apiDuplicated.current = false;
            return false;
        }*/

        apiDuplicated.current = true;
        axiApi
            .post("/api/home/containers/range/", { min: min, max: max })
            .then((resp) => {
                if (resp.data.status) {
                    let totalData = { total: 0, count: 0 };
                    let waste = {};
                    let wastesData = [];
                    resp.data.totals.forEach((item) => {
                        totalData.total += item.count;
                        waste = {
                            type: item.waste_type,
                            count: 0,
                            percent: 0,
                            total: item.count,
                        };
                        if (item.waste_type in resp.data.containers) {
                            totalData.count += resp.data.containers[item.waste_type].count;
                            waste.count = resp.data.containers[item.waste_type].count;
                            waste.percent = resp.data.containers[item.waste_type].filling;
                        }
                        wastesData.push(waste);
                    });
                    setWastes(wastesData);
                    setTotals(totalData);
                } else {
                    Alert.error("Error in ContainersRange.getContainers()", "Se ha encontrado un error en la carga del mapa.");
                }
            })
            .catch((error) => {
                console.log(error);
                Alert.error("Error in ContainersRange.getContainers()", "Se ha encontrado un error en la carga del mapa.");
            });
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            getContainers(minValue, maxValue);
        }, 10);
        return () => clearTimeout(timer);
    }, [minValue, maxValue]);

    return (
        <>
            <div className=" border p-3">
                <div className="row">
                    <div className="col-12 d-flex justify-content-between align-items-center">
                        <div>
                            {_Tf("labels.containers")} {_Tf("labels.selected")}:
                        </div>
                        <div>
                            <span className="h2">{totals.count}</span> <span className="h4 fw-light">/ {totals.total}</span>
                        </div>
                    </div>
                    <hr className="col-12 mt-2" />
                </div>
                <div className="row">
                    <div className="col-12 mt-4">
                        <div>
                            <span>{_Tt("containers.filling_threshold")}:</span>&nbsp;
                            <span style={styleText}>{minValue}</span>&nbsp;
                            <span>/</span>&nbsp;
                            <span style={styleText}>{maxValue}</span>
                        </div>
                        <MultiRangeSlider
                            labels={["0%", "25%", "50%", "75%", "100%"]}
                            step={5}
                            min={0}
                            max={100}
                            minValue={60}
                            maxValue={100}
                            onChange={(e) => {
                                setMinValue(e.minValue);
                                setMaxValue(e.maxValue);
                            }}
                        />
                    </div>
                    <div className="col-12 mt-3 text-center">
                        {wastes
                            .filter((waste) => waste.count > 0)
                            .map((waste, idx) => (
                                <div className="d-inline-block p-2" key={idx}>
                                    <ContainerProgressCircle percent={waste.percent} type={waste.type} />
                                    <div className="text-center">
                                        <span className="h4">{waste.count}</span>
                                        <span className="h5 fw-light">&nbsp;/ {waste.total}</span>
                                    </div>
                                </div>
                            ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default ContainersRange;
